export {default} from './YourSchoolMapSection';
